import Vue from "vue";
import Router from "vue-router";
import store from './store'
import axios from 'axios'

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("./components/mains/login"),
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./components/mains/signup"),
    },
    {
      path: "/",
      name: "Home",
      props: true,
      component: () => import("./components/home/Home"),
    },
    {
      path: "/apexcahrt",
      name: "apexchart",
      component: () => import("./components/home/ApexChart"),
    },
    {
      path: "/observationreport",
      name: "observationreport",
      props: true,
      component: () => import("./components/observation/ObserveMain"),
      meta: {
        label: 'observationreport',
        requiresAuth: true,
      },
    },
    {
      path: "/rescuereport",
      name: "rescuereport",
      props: true,
      component: () => import("./components/rescue/RescueMain"),
      meta: {
        label: 'rescureport',
        requiresAuth: true,
      },
    },
    {
      path: "/profile",
      name: "profile",
      props: true,
      component: () => import("./components/profile/Profile"),
      meta: {
        label: 'Profile',
        requiresAuth: true,
      },
    },
    {
      path: '/details/:id',
      name: "details",
      component: () => import("./components/profile/Details"),
      props:true
    },
    {
      path: "/about",
      name: "about",
      component: () => import("./components/about/AboutMain"),
    },
    {
      path:'/submit',
      name: 'submit',
      component: () =>
      import ('./components/observation/newon'),
    },
    {
      path:'/Search/:keyword',
      name: 'Search',
      component: () =>
      import ('./components/Search'),
      props:true
    },
    {
      path:'/terms',
      name: 'terms',
      component: () =>
      import ('./components/TermsCondetions.vue'),
    },
   
    {
      path:'/team',
      name: 'team',
      component: () =>
      import ('./components/Team.vue'),
    },
    {
      path:'/map',
      name: 'map',
      component: () =>
      import ('./components/Mapview.vue'),
    },
    {
      path:'/seaturtles/:type',
      name: 'seaturtles',
      props: true,
      component: () =>
      import ('./components/Turtles/seaTurtles.vue'),
    },
    {
      path:'/seaturtles2/:id',
      name: 'seaturtles2',
      props: true,
      component: () =>
      import ('./components/Turtles/seaTurtles2.vue'),
    },
    {
      path:'/glossary/:type',
      name: 'glossary',
      props: true,
      component: () =>
      import ('./components/Turtles/glossary.vue'),
    },
    {
      path:'/locate/:id',
      name: 'Locate',
      props:true,
      component: () =>
      import ('./components/profile/Locate'),
    },
    {
      path: "/contact",
      name: "contact",
      
      component: () => import("./components/Contact.vue"),
    },
  ],
})

router.beforeEach((to, from, next) => {

	if (to.matched.some(route => route.meta.requiresAuth == true) && store.state.isLoggedIn == false) {
		console.log(from)
		next({ name: 'Login', params: { lastPage: from } })
		return
	}
	if (store.state.isLoggedIn == true) {
		axios({
			method: 'POST',
			url: '/validate/token',
			headers: {
				'x-auth-token': localStorage.getItem('token')
			}
		}).then(response => {
			if (!response.data.status) {
				store.commit("sessionOut", true)
				return
			}
		})
			.catch(err => {
				var msg = err;
				console.log(msg)
			});
	}
	if (to.name == 'Login' && store.state.isLoggedIn == true ) {
		next({ name: 'Home' })
		return
	}
	if (to.matched.some(route => route.meta.requiresAuth == false) && store.state.isLoggedIn == true) {
		next({ name: 'Home' })
		return
	}

	next()
})

export default router;